import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16.853 10.647a.5003.5003 0 0 0-.707 0L12 14.793V3.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v11.293l-4.146-4.146c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l5 5c.098.098.226.146.354.146s.256-.049.354-.147l5-5a.5003.5003 0 0 0 0-.707l-.002.001z',
    'M19.5 20h-16c-.827 0-1.5-.673-1.5-1.5v-2c0-.276.224-.5.5-.5s.5.224.5.5v2c0 .276.224.5.5.5h16c.276 0 .5-.224.5-.5v-2c0-.276.224-.5.5-.5s.5.224.5.5v2c0 .827-.673 1.5-1.5 1.5z',
  ],
  height: 24,
  width: 24,
});
